import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Grid, Typography, Button } from '@material-ui/core'
import { getIcon } from 'utils/GetIcon'
import Topbar from '../../layouts/Minimal/components/Topbar'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  content: {
    paddingTop: 150,
    textAlign: 'center',
  },
  title: {
    fontWeight: 450,
    color: theme.palette.primary.light,
    lineHeight: 'unset',
    marginBottom: theme.spacing(4),
  },
  pageNotFound: {
    lineHeight: 'unset',
    marginBottom: theme.spacing(2),
    marginTop: -theme.spacing(2),
  },
}))

const NotAvailable = (props) => {
  const classes = useStyles()
  const { history } = props

  const handleBack = () => {
    history.push('/dashboard')
  }

  return (
    <div className={classes.root}>
      <Topbar />
      <Grid container justify="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <div className={classes.content}>
            <Typography variant="h1" className={classes.title}>
              Evaluation is unavailable to complete
            </Typography>
            <Typography variant="h3" className={classes.pageNotFound}>
              The requested evaluation is not available to complete because the evaluation is no longer active, is
              before the start date or has been removed.
            </Typography>
            <Typography variant="subtitle1">If you think this was a mistake, please contact your HR Admin</Typography>
            <Button startIcon={getIcon('back')} onClick={handleBack}>
              Go Back to Dashboard
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default NotAvailable
